class PermissionService {
  getStorageKeys() {
    const keycloakUrl = (window as any).KEYCLOAK_AUTHORITY_URL || (window as any).API_FINX_AUTH
    const realm = (window as any).KEYCLOAK_REALM || 'finx'
    const clientId = (window as any).KEYCLOAK_CLIENT_ID || 'finx-front'

    return [
      `oidc.user:${(window as any).API_FINX_AUTH}:portal-client-2`,
      // `oidc.user:${keycloakUrl}/realms/${realm}:${clientId}`,
    ]
  }

  get userData() {
    const storedUser = this.getStorageKeys()
      .map(key => localStorage.getItem(key))
      .find(Boolean)

    if (!storedUser) {
      return null
    }

    try {
      return JSON.parse(storedUser)
    } catch (error) {
      console.error('Erro ao fazer parse das permissoes do usuario:', error)
      return null
    }
  }

  hasPermission(permission: string) {
    if (this.permissions) {
      return !!this.permissions.find(item => item === permission || item === '*')
    }

    return false
  }

  get permissions() {
    if (!this.userData || !this.userData.profile || !this.userData.profile.permissoes) {
      return []
    }

    const permissions = this.userData.profile.permissoes

    if (typeof permissions === 'string') {
      return [permissions]
    }

    if (Array.isArray(permissions)) {
      return permissions
    }

    return Object.values(permissions)
  }
}

// eslint-disable-next-line import/prefer-default-export
export const permissionService = new PermissionService()
